import React, { useMemo, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const API =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";

const CalificarMasivoPorInstancia = () => {
  const [textoDnis, setTextoDnis] = useState("");
  const [instanciaId, setInstanciaId] = useState("");
  const [procesoId, setProcesoId] = useState("");
  const [estado, setEstado] = useState("rechazado");
  const [observaciones, setObservaciones] = useState("Actualización masiva");
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);

  const dnisParseados = useMemo(() => {
    return textoDnis
      .split(/[\s,;\n\r]+/)
      .map((dni) => dni.trim())
      .filter(Boolean)
      .map((dni) => dni.replace(/\D/g, ""))
      .filter(Boolean)
      .map(Number)
      .filter((dni, index, arr) => dni && arr.indexOf(dni) === index);
  }, [textoDnis]);

  const enviarCalificacionMasiva = async () => {
    if (dnisParseados.length === 0) {
      return Swal.fire("Atención", "Pegá al menos un DNI válido", "warning");
    }

    if (!instanciaId || !procesoId) {
      return Swal.fire(
        "Atención",
        "Completá instancia_id y proceso_id",
        "warning"
      );
    }

    if (!["aprobado", "rechazado"].includes(estado)) {
      return Swal.fire(
        "Atención",
        "El estado debe ser aprobado o rechazado",
        "warning"
      );
    }

    const confirm = await Swal.fire({
      title: "¿Confirmar calificación masiva?",
      html: `
        <b>DNIs:</b> ${dnisParseados.length}<br/>
        <b>Instancia:</b> ${instanciaId}<br/>
        <b>Proceso:</b> ${procesoId}<br/>
        <b>Estado:</b> ${estado}
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, procesar",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);
    setResultado(null);

    try {
      const body = {
        dnis: dnisParseados,
        instancia_id: Number(instanciaId),
        proceso_id: Number(procesoId),
        estado,
        observaciones: observaciones || "Actualización masiva",
      };

      const { data } = await axios.post(
        `${API}/calificarMasivoPorInstancia`,
        body
      );

      setResultado(data);

      Swal.fire(
        "Listo",
        data?.mensaje || "Calificación masiva procesada correctamente",
        "success"
      );
    } catch (error) {
      console.error("❌ Error calificación masiva:", error);

      Swal.fire(
        "Error",
        error?.response?.data?.mensaje ||
          error?.response?.data?.error ||
          "No se pudo procesar la calificación masiva",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.contenedor}>
      <h2 style={styles.titulo}>Calificación masiva por instancia</h2>

      <div style={styles.card}>
        <label style={styles.label}>DNIs</label>
        <textarea
          value={textoDnis}
          onChange={(e) => setTextoDnis(e.target.value)}
          placeholder={`Pegá los DNIs separados por enter, coma, espacio o punto y coma\nEj:\n30548471\n30111222\n29222333`}
          rows={8}
          style={styles.textarea}
        />

        <div style={styles.preview}>
          DNIs detectados: <b>{dnisParseados.length}</b>
        </div>

        {dnisParseados.length > 0 && (
          <div style={styles.dnisBox}>
            {dnisParseados.slice(0, 50).map((dni) => (
              <span key={dni} style={styles.dniTag}>
                {dni}
              </span>
            ))}

            {dnisParseados.length > 50 && (
              <span style={styles.dniTag}>
                +{dnisParseados.length - 50} más
              </span>
            )}
          </div>
        )}

        <div style={styles.grid}>
          <div>
            <label style={styles.label}>instancia_id</label>
            <input
              type="number"
              value={instanciaId}
              onChange={(e) => setInstanciaId(e.target.value)}
              placeholder="Ej: 31"
              style={styles.input}
            />
          </div>

          <div>
            <label style={styles.label}>proceso_id</label>
            <input
              type="number"
              value={procesoId}
              onChange={(e) => setProcesoId(e.target.value)}
              placeholder="Ej: 1"
              style={styles.input}
            />
          </div>

          <div>
            <label style={styles.label}>Estado</label>
            <select
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              style={styles.input}
            >
              <option value="rechazado">Rechazado</option>
              <option value="aprobado">Aprobado</option>
            </select>
          </div>
        </div>

        <label style={styles.label}>Observaciones</label>
        <input
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          placeholder="Actualización masiva"
          style={styles.input}
        />

        <button
          onClick={enviarCalificacionMasiva}
          disabled={loading}
          style={{
            ...styles.boton,
            opacity: loading ? 0.6 : 1,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Procesando..." : "Enviar calificación masiva"}
        </button>
      </div>

      {resultado && (
        <div style={styles.resultado}>
          <h3>Resultado</h3>

          <div style={styles.resumenGrid}>
            <ResumenItem
              titulo="Personas recibidas"
              valor={resultado?.resumen?.personas_recibidas}
            />
            <ResumenItem
              titulo="Items instancia"
              valor={resultado?.resumen?.items_en_instancia}
            />
            <ResumenItem
              titulo="Creados"
              valor={resultado?.resumen?.creados}
            />
            <ResumenItem
              titulo="Actualizados"
              valor={resultado?.resumen?.actualizados}
            />
            <ResumenItem
              titulo="Omitidos aprobados"
              valor={resultado?.resumen?.omitidos_aprobados}
            />
            <ResumenItem
              titulo="Etapas actualizadas"
              valor={resultado?.resumen?.etapas_actualizadas}
            />
            <ResumenItem
              titulo="Etapas no encontradas"
              valor={resultado?.resumen?.etapas_no_encontradas}
            />
            <ResumenItem
              titulo="Errores"
              valor={resultado?.resumen?.errores}
            />
          </div>

          <details style={{ marginTop: "15px" }}>
            <summary>Ver detalle completo</summary>
            <pre style={styles.pre}>
              {JSON.stringify(resultado.detalle, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
};

const ResumenItem = ({ titulo, valor }) => (
  <div style={styles.resumenItem}>
    <span>{titulo}</span>
    <strong>{valor ?? 0}</strong>
  </div>
);

const styles = {
  contenedor: {
    maxWidth: "900px",
    margin: "20px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  titulo: {
    marginBottom: "15px",
  },
  card: {
    background: "#fff",
    borderRadius: "14px",
    padding: "20px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
  },
  label: {
    display: "block",
    fontWeight: "bold",
    marginBottom: "6px",
    marginTop: "12px",
  },
  textarea: {
    width: "100%",
    borderRadius: "10px",
    border: "1px solid #ccc",
    padding: "12px",
    fontSize: "15px",
    resize: "vertical",
  },
  input: {
    width: "100%",
    borderRadius: "10px",
    border: "1px solid #ccc",
    padding: "10px",
    fontSize: "15px",
    boxSizing: "border-box",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "10px",
  },
  preview: {
    marginTop: "8px",
    fontSize: "14px",
  },
  dnisBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    marginTop: "10px",
    maxHeight: "100px",
    overflowY: "auto",
  },
  dniTag: {
    background: "#eef2ff",
    border: "1px solid #c7d2fe",
    borderRadius: "20px",
    padding: "4px 10px",
    fontSize: "13px",
  },
  boton: {
    marginTop: "18px",
    width: "100%",
    border: "none",
    borderRadius: "10px",
    padding: "13px",
    background: "#1f2937",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "15px",
  },
  resultado: {
    marginTop: "20px",
    background: "#fff",
    borderRadius: "14px",
    padding: "20px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
  },
  resumenGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "10px",
  },
  resumenItem: {
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  pre: {
    background: "#111827",
    color: "#e5e7eb",
    padding: "15px",
    borderRadius: "10px",
    overflowX: "auto",
    maxHeight: "400px",
  },
};

export default CalificarMasivoPorInstancia;